import React, { type FC } from 'react';

interface ConfluenceLogoIconProps {
	/**
	 * Accessible label for the icon. When provided, the SVG is treated as a
	 * meaningful image (`role="img"`). When omitted, it is treated as decorative
	 * (`aria-hidden="true"`, `role="presentation"`).
	 */
	label?: string;
	/** Fill color — pass an ADS design token. Defaults to `currentColor`. */
	color?: string;
}

/**
 * Inline SVG Confluence logo icon. Accepts a `color` prop (ADS design token)
 * so it adapts to dark mode and high-contrast themes.
 * Defaults to `currentColor` to inherit the surrounding text color as a fallback.
 */
export const ConfluenceLogoIcon: FC<ConfluenceLogoIconProps> = ({
	label,
	color = 'currentColor',
}) => (
	<svg
		width="16"
		height="16"
		viewBox="0 -0.5 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={label || undefined}
		role={label ? 'img' : 'presentation'}
		aria-hidden={label ? undefined : true}
	>
		<path
			d="M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z"
			fill={color}
		/>
	</svg>
);
